import React from 'react';
import { Minimize } from 'lucide-react';

interface KioskContainerProps {
  children: React.ReactNode;
  isKioskMode: boolean;
  toggleKioskMode: () => void;
}

const KioskContainer: React.FC<KioskContainerProps> = ({ children, isKioskMode, toggleKioskMode }) => {
  if (isKioskMode) {
    return (
      <div className="fixed inset-0 z-[100] overflow-hidden flex flex-col animate-in fade-in duration-300">
          {/* Subtle Exit Button for Staff */}
          <div className="absolute top-4 right-4 z-50 opacity-0 hover:opacity-100 transition-opacity duration-1000">
               <button 
                  onClick={toggleKioskMode} 
                  className="bg-black/20 text-white/50 hover:text-white p-3 rounded-full backdrop-blur-md transition-colors border border-white/10"
                  title="Exit Kiosk Mode"
               >
                  <Minimize size={24} />
               </button>
          </div>
          <div className="flex-1 w-full h-full">
             {children}
          </div>
      </div>
    );
  }
  // Normal Mode - standard padding wrapper
  return <div className="py-4">{children}</div>;
};

export default KioskContainer;